<template>
  <layout>
    <div slot="content">
      <i-card title="船票库存">
        <div slot="content">
          <div class="sailings-info">
            当前航班：{{sailingsInfo.sailings_title}}
            ({{sailingsInfo.sailings_code}},{{sailingsInfo.start_time}} ~ {{sailingsInfo.end_time}},
            {{sailingsInfo.start_wharf}} ~ {{sailingsInfo.end_wharf}})
          </div>
          <div class="week-container">
            <div class="week">周日</div>
            <div class="week">周一</div>
            <div class="week">周二</div>
            <div class="week">周三</div>
            <div class="week">周四</div>
            <div class="week">周五</div>
            <div class="week">周六</div>
          </div>
          <div class="date-container">
            <div class="date" v-if="stockList.length > 0"
                 v-for="i in parseInt(stockList[0].week)"></div>
            <div class="date" v-for="(item,index) in stockList" title="点击库存修改">
              <div class="date-number">{{item.date}}</div>
              <div class="stock" @click="editStockDialog(item)">{{item.stock}}<span style="font-size: 12px;">张</span></div>
            </div>
          </div>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
  export default {
    name: "sailings_stock",
    data() {
      return {
        stockList: [{week: 0}],
        currStock: {},
        sailingsInfo:{}
      }
    },
    methods: {
      getStockList: function () {
        let sailingsId = this.$route.query.sailings_id;
        this.$http.request('sailingsStockList', {sailings_id: sailingsId}).then(res => {
          this.stockList = res.data;
        });
      },
      doEditStock: function (stock) {
        let params = {
          sailings_id: this.currStock.sailings_id,
          date: this.currStock.date,
          stock: stock
        };
        this.$http.request('editSailingsStock', params).then(res => {
          this.getStockList();
        });
      },
      editStockDialog: function (stockInfo) {
        this.currStock = stockInfo;
        let _self = this;
        this.$prompt('请输入' + stockInfo.date + '的库存信息,当前库存:'+stockInfo.stock, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({value}) => {
          _self.doEditStock(value);
        });
      },
      getSailingsInfo:function () {
        let sailingsId = this.$route.query.sailings_id;
        if (sailingsId) {
          this.$http.request('getSailingsInfo', {sailings_id: sailingsId}).then((res) => {
            if (res.status === 'success') {
              if (!res.data) {
                this.$message({
                  message: '航班不存在',
                  type: 'danger'
                });
              } else {
                this.sailingsInfo = res.data;
              }
            }
          });
        }
      }
    },
    created: function () {
      this.getStockList();
      this.getSailingsInfo();
    }
  }
</script>

<style scoped lang="less">
  .week-container {
    width: 100%;
    background: #f5f5f5;
    display: flex;
    border-left: 1px solid @border-color;
  }

  .week-container .week {
    padding: 10px;
    justify-content: space-between;
    width: 14.285%;
    text-align: center;
    font-size: 12px;
    border-right: 1px solid @border-color;
    border-top: 1px solid @border-color;
  }

  .date-container {
    width: 100%;
    display: flex;
    flex-flow: wrap;
    border-left: 1px solid @border-color;
  }

  .date-container .date {
    height: 130px;
    border-right: 1px solid @border-color;
    justify-content: space-between;
    width: 14.285%;
    flex-wrap: wrap;
    border-bottom: 1px solid @border-color;
    font-size: 12px;
  }

  .date-container .date:hover {
    background: #eee;
  }

  .date-number {
    padding: 10px;
    font-size: 13px;

  }

  .stock {
    text-align: center;
    font-size: 30px;
    padding-top: 20px;
    color: @main-color;
    cursor: pointer;
  }
  .sailings-info{
    font-size: 14px;
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/settings/sailings_stock.vue